export default __webpack_public_path__ + "static/media/Pınar_Öncü_AHV_In_Moms_We_Trust.431841bf.jpg";